// libs
import React from 'react';

// icons
import ArrowRight from '@nykaa/ui-components/Icons/chevron-right-small';

// types
import { BreadCrumbs } from 'shared/types/breadCrumbs';

// styles
import {
  Crumb,
  BreadCrumbWrapper,
  ArrowWrapper,
  ProductTitle,
  CrumbArrowWrapper,
  BreadCrumpParent,
} from './styles';

const ARROW_RIGHT_SIZE = '10px';

// defs
interface BreadCrumbProps {
  breadCrumbs: BreadCrumbs;
  productTitle: string;
  isMobile?: boolean;
  className?: string;
}

const BreadCrumb = ({
  breadCrumbs,
  productTitle,
  isMobile = false,
  className,
}: BreadCrumbProps) => {
  if (!breadCrumbs.length) return null;

  return (
    <BreadCrumpParent isMobile={isMobile} className={className}>
      <BreadCrumbWrapper data-test="breadcrumb-wrapper">
        {breadCrumbs?.map(({ key, value }, indx) => {
          if (key === productTitle) return null;
          return (
            <CrumbArrowWrapper stickyCrumb={indx == 0} key={indx}>
              <Crumb href={value}>{isMobile ? <u>{key}</u> : key}</Crumb>
              <ArrowWrapper>
                <ArrowRight size={ARROW_RIGHT_SIZE} />
              </ArrowWrapper>
            </CrumbArrowWrapper>
          );
        })}
        <ProductTitle>{productTitle}</ProductTitle>
      </BreadCrumbWrapper>
    </BreadCrumpParent>
  );
};

export default BreadCrumb;
